







// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
    name: 'IsActiveBadge'
})
export default class IsActiveBadge extends Vue {
    @Prop({ required: true, type: [Number, Boolean] }) readonly status!: number|boolean
    @Prop({ default: '', type: String }) readonly text!: string
    @Prop({ default: '', type: String }) readonly variant!: string

    get label (): string {
        if (this.text === '') {
            return this.status ? 'ACTIVO' : 'INACTIVO'
        }
        return this.text
    }

    get color (): string {
        if (this.variant === '') {
            return this.status ? 'success' : 'warning'
        }
        return this.variant
    }
}
